import React from 'react';
import { Button, Typography, IconButton, Paper } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { RemoveRedEye } from '@mui/icons-material';
import { D, Loading } from '../include';
import Moment from 'react-moment';
import 'moment/locale/pt-br';
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement } from 'chart.js'

ChartJS.register(ArcElement)

export class Equipament extends React.Component {
  constructor(props) {
    super(props);
    this.update = this.update.bind(this);
    this.state = { data: null };
  }

  componentDidMount = () => {
    this.interval = setInterval(() => this.update(), 2000);
    this.update();
  };

  componentWillUnmount = () => clearInterval(this.interval);

  update = () => {
    this.props.api.get('/server').then((r) => this.setState({ data: r }));
  };

  render() {
    return (
      <>
        {!!this.state.data ? (
          <D className="col e aF scD" style={{ padding: '2rem 4rem' }}>
            <D className="row w aC">
              <Typography variant="h6">{'Nome do host: ' + this.state.data.hostname}</Typography>
            </D>
            <D h="2rem" />
            <D className="row w aC">
              {this.state.data.so + ' ' + this.state.data.kernel_version + ' -'}&nbsp;
              <Moment locale="en" parse="dddd D, MMMM YYYY" date={this.state.data.running_since} toNow ago />{' '}
              &nbsp;{'online - ' + this.state.data.num_cpu_cores.toString() + ' cores / ' + this.state.data.num_processes + ' procs'}
            </D>
            <D h="2rem" />
            {/* Doughnut charts for system stats */}
            <D className="row w aC" style={{ padding: '1rem' }}>
              {/* CPU Usage */}
              <D className="col e aC" style={{ width: '80px' }}>
                <Typography variant="subtitle1" color="textSecondary">Processador</Typography>
                <Doughnut
                  data={{
                    datasets: [
                      {
                        data: [this.state.data.cpu_usage, 100 - this.state.data.cpu_usage],
                        backgroundColor: ['#ffb300', '#eee'],
                      },
                    ],
                  }}
                />
                <Typography variant="subtitle1" color="textSecondary">
                  {this.state.data.cpu_usage.toFixed(0) + '%'}
                </Typography>
              </D>
              {/* RAM Usage */}
              <D size="2rem" />
              <D className="col e aC" style={{ width: '80px' }}>
                <Typography variant="subtitle1" color="textSecondary">RAM ({this.state.data.memo_ram.toFixed(0)} GB)</Typography>
                <Doughnut
                  data={{
                    datasets: [
                      {
                        data: [
                          this.state.data.memo_ram_usage,
                          this.state.data.memo_ram - this.state.data.memo_ram_usage,
                        ],
                        backgroundColor: ['#ffb300', '#eee'],
                      },
                    ],
                  }}
                />
                <Typography variant="subtitle1" color="textSecondary">
                  {this.state.data.memo_ram_usage.toFixed(1) + ' GB'}
                </Typography>
              </D>
              {/* Swap Usage */}
              <D size="2rem" />
              <D className="col e aC" style={{ width: '80px' }}>
                <Typography variant="subtitle1" color="textSecondary">Swap ({this.state.data.memo_swap} GB)</Typography>
                <Doughnut
                  data={{
                    datasets: [
                      {
                        data: [
                          this.state.data.memo_swap_usage,
                          this.state.data.memo_swap - this.state.data.memo_swap_usage,
                        ],
                        backgroundColor: ['#ffb300', '#eee'],
                      },
                    ],
                  }}
                />
                <Typography variant="subtitle1" color="textSecondary">
                  {this.state.data.memo_swap_usage.toFixed(1) + 'GB'}
                </Typography>
              </D>
              {/* Disk Usage */}
              <D size="2rem" />
              <D className="col e aC" style={{ width: '80px' }}>
                <Typography variant="subtitle1" color="textSecondary">Disco ({this.state.data.disk_size.toFixed(0)} GB)</Typography>
                <Doughnut
                  data={{
                    datasets: [
                      {
                        data: [
                          this.state.data.disk_size * this.state.data.disk_size_usage / 100.0,
                          this.state.data.disk_size * (1 - this.state.data.disk_size_usage / 100.0),
                        ],
                        backgroundColor: ['#ffb300', '#eee'],
                      },
                    ],
                  }}
                />
                <Typography variant="subtitle1" color="textSecondary">
                  {(this.state.data.disk_size * this.state.data.disk_size_usage / 100.0).toFixed(1) + ' GB'}
                </Typography>
              </D>
            </D>
            <D h="2rem" />
            <D className="row w aC">
              <Button variant="outlined" color="primary" onClick={() => this.props.dialogClose()}>
                Fechar
              </Button>
            </D>
          </D>
        ) : (
          <D className="row e aC" style={{ minWidth: '200px', minHeight: '200px' }}>
            <Loading />
          </D>
        )}
      </>
    );
  }
}

export class Servers extends React.Component {
  constructor(props) {
    super(props);
    this.updateData = this.updateData.bind(this);
    this.state = {
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
    };
  }

  componentDidMount = () => {
    this.updateData(this.state.page, this.state.pageSize);
  };

  updateData = (page, pageSize) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Equipments', { params: { page, pageSize } })
      .then((response) => {
        const rows = response.computers || [];
        const totalRows = Number(response.total) || 0;
        this.setState({ dataTable: rows, totalRows, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  render() {
    const { dataTable, loading, page, pageSize, totalRows } = this.state;

    const columns = [
      {
        field: 'control',
        headerName: 'Controle',
        align: 'center',
        headerAlign: 'center',
        width: 100,
        renderCell: (params) => (
          <IconButton
            style={{ color: '#aaa' }}
            onClick={() =>
              this.props.dialog(
                <Equipament api={this.props.api} row={params.row} dialogClose={() => this.props.dialogClose()} />
              )
            }
          >
            <RemoveRedEye />
          </IconButton>
        ),
      },
      {
        field: 'status',
        headerName: 'Status',
        align: 'center',
        headerAlign: 'center',
        width: 100,
        renderCell: (params) => {
          return params.row.status === false ? (
            <span style={{ color: 'red', fontWeight: 'bold' }}>Inativo</span>
          ) : (
            <span style={{ color: 'green', fontWeight: 'bold' }}>Ativo</span>
          );
        },
      },
      {
        field: 'id',
        headerName: 'ID',
        width: 150,
      },
      {
        field: 'ip',
        headerName: 'IP',
        width: 200,
      },
      {
        field: 'description',
        headerName: 'Descrição',
        flex: 1,
      },
    ];

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <Paper sx={{ width: '100%', height: '800px' }}>
          <DataGrid
            rows={dataTable || []}
            columns={columns || []}
            pagination
            paginationMode="server"
            rowCount={Number(totalRows)}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
            components={{
              NoRowsOverlay: () => (
                <D style={{ padding: '2rem', textAlign: 'center' }}>Nenhum servidor encontrado</D>
              ),
              LoadingOverlay: () => (
                <D style={{ padding: '2rem', textAlign: 'center' }}>
                  <Loading />
                </D>
              ),
            }}
          />
        </Paper>
      </D>
    );
  }
}
